import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import './request-install-modal';

class RequestInstallButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity || !this.entity.hasAction('generate-installation-request')) {
      return html``;
    }
    return html`
      <button class="button button--contained" @click="${this._onClick}">Request Installation</button>
      <request-install-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
        @response="${() => entityStore.invalidateHref(this.href)}"
      ></request-install-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('request-install-button', RequestInstallButton);
